import { render, staticRenderFns } from "./invigilatorProfile.vue?vue&type=template&id=18c2102e&"
import script from "./invigilatorProfile.vue?vue&type=script&lang=js&"
export * from "./invigilatorProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports